export default __webpack_public_path__ + "static/media/tier-two-monster.2599ec77.png";